export default "__VITE_ASSET__BssbWeck__"